/**
 * Created by intellicar-rinas on 9/12/17.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import './InToast.css'
import actions from '../../store/actions';
import Dom from '../../helpers/Dom';

class InToast extends Component {

    constructor () {
        super();
        ['close', 'getToast', 'processToasts', 'autoClose', 'closeToast'].map(i=>this[i]=this[i].bind(this));
    }

    state = {
        InToast: false,
        hide: false,
    }

    latestAlertTime = 0;

    close() {

    }

    getToast() {
        return this.state.InToast && this.state.InToast.data ? this.state.InToast.data : [];
    }
    hideNotification =  () => {
        this.setState({hide: !this.state.hide})
    }

    autoClose(Toast) {
        setTimeout(()=>{
            this.closeToast(Toast)
        }, Toast.autoClose)
    }
    gotoMap ( item ) {
        if(item.lat && item.lng){
            window.showInGoogleMaps(item.lat, item.lng);
        }
    }
    closeToast(Toast) {
        for(let idx in this.props.InToast.data) {
            if(this.props.InToast.data[idx].createAt === Toast.createAt) {
                idx = parseInt(idx, 10);
                this.props.InToast.data.splice(idx, 1);
                this.props.dispatch({
                    type: actions.UPDATE_INTOAST_LIST,
                    data: this.props.InToast.data
                });
                break;
            }
        }
    }

        handleCopy(item) {
            if (item.lat && item.lng) {
                const url = `https://www.google.com/maps?q=${item.lat},${item.lng}`;
        
                const textarea = document.createElement('textarea');
                textarea.value = url;
                textarea.style.position = 'fixed'; // Prevent scroll jump
                textarea.style.left = '-9999px';   // Keep it off-screen
                document.body.appendChild(textarea);
                textarea.focus();
                textarea.select();
                try {
                    document.execCommand('copy');
                } catch (err) {
                    console.error('Copy exception:', err);
                }
                document.body.removeChild(textarea);
            }
        }

    processToasts(Toasts) {
        this.setState({animate: false});
        setTimeout(()=> {
            this.setState({animate: true});
        },100)
        for(let idx in Toasts) {
            if(Toasts[idx].processed !== true) {
                Toasts[idx].processed = true;
                this.latestAlertTime = Toasts[idx].createAt > this.latestAlertTime ? Toasts[idx].createAt : this.latestAlertTime;
                if(Toasts[idx].autoClose) {
                    this.autoClose(Toasts[idx]);
                }
            }
        }
    }

    componentWillReceiveProps(props) {
        if(!this.lastUpdated || props.InToast.updatedAt !== this.lastUpdated) {
            this.processToasts(props.InToast.data);
            this.setState({popout: true})
            setTimeout(()=> {
                this.setState({popout: false, InToast: props.InToast})
            }, 300);
        }
    }

    getInToastClassName =()=> {
        let className = 'InToast ';
        if(this.props.reportWindow.visible && this.props.reportWindow.tab && this.props.reportWindow.tab.key) {
            className += 'reportWindow ' + this.props.reportWindow.tab.key;
        }
        return className;
    }

    sort =(a,b)=> {
        return b.createAt - a.createAt;
    }

    isNewToast =toast=> {
        if(toast.createAt >= this.latestAlertTime && !toast.onceIWasNew) {
            toast.onceIWasNew = true;
            return true;
        }
        return false;
    }

    isLastToast =toast=> {
        return toast.createAt >= this.latestAlertTime;
    }

    render() {
        return (
            <div className={this.getInToastClassName()}>
                {
                    !this.state.hide && this.getToast().slice(Math.max(0, this.getToast().length - 4)).sort(this.sort).map((item,index)=>{
                        return (
                            <div key={index} className={"it-container " + 
                                (index === 0 && !this.state.popout && this.isNewToast(item) ? this.state.animate ? ' anim' : ' noanim' : '') + 
                                (index === 3 && this.getToast().length > 4 ? this.state.popout ? ' popoutanim' : '' : '') + 
                                (this.isLastToast(item) ? ' newitem ' : '' )}>
                                <div className="itc-head">
                                    <div className="itch-name">{item.name}</div>
                                    {item && item.viewInMap ? <div className="itch-viewInmap" onClick={() =>this.gotoMap(item)}>Show on map</div> : null}
                                   { item && item.viewInMap ? <span className='itch-copy' onClick={() => this.handleCopy(item)}>
                                        <i className="fa fa-clone" aria-hidden="true"></i>
                                    </span>:null}
                                    <div className="itch-close" onClick={()=>this.closeToast(item)}><i className="fa fa-times"></i></div>
                                </div>
                                <div className="itc-body">{item.content}</div>
                            </div>
                        )
                    })
                }
                {this.getToast().length > 4 ? (
                    <div className="it-container">
                        <div className="itc-head" style={{display:"flex",justifyContent:"space-between"}}>
                            <div className="itch-name">{this.getToast().length - 4} more notifications </div>
                            <div className='itch-hide'><button onClick={() => this.hideNotification()}> {!this.state.hide ? "Hide notifications" : "Show notifications"}</button></div>
                        </div>
                    </div>
                ): ''}
            </div>
        )
    }

}


const MapPropsToState = (state) => {
    return {InToast: state.InToast, reportWindow:state.reportWindow}
};

export default connect(MapPropsToState)(InToast);